import { render } from "./RecommendationsPage.vue?vue&type=template&id=3b9ec6d0"
import script from "./RecommendationsPage.vue?vue&type=script&lang=js"
export * from "./RecommendationsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__